(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["teamwear-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('teamwear-form-loader')) {
    class TeamwearFormLoader extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;

        this.host = this.closest('dialog-component');
        this.status = this.querySelector('[data-status]');
        this.pending = null;
        this.loaded = false;
        this.sentKey = 'teamwear-form-sent:' + window.location.pathname;
        this.cacheKey = 'teamwear-form-html:' + window.location.pathname;

        // Capture phase: runs before anything else can stop the submit event.
        this.addEventListener('submit', this, true);

        if (this.host) {
          // Start loading as soon as someone is about to open the pop-up.
          this.host.addEventListener('dialog:open', this);
          this.host.addEventListener('pointerover', this, { passive: true });
          this.host.addEventListener('touchstart', this, { passive: true });
          this.host.addEventListener('focusin', this);
        }

        const state = this.returnState();
        if (state || !this.host) this.load(state);
      }

      disconnectedCallback() {
        if (!this.host) return;

        this.host.removeEventListener('dialog:open', this);
        this.host.removeEventListener('pointerover', this);
        this.host.removeEventListener('touchstart', this);
        this.host.removeEventListener('focusin', this);
      }

      handleEvent(event) {
        if (event.type === 'submit') {
          // Remember that the form was sent from this page. After Shopify reloads the page,
          // returnState() uses it to show the thank you message.
          const form = this.querySelector('teamwear-form');
          if (form && form.sending) this.store(this.sentKey, String(Date.now()));
          return;
        }

        this.load(null);
      }

      /**
       * Shopify sends the visitor back to this page after the form was posted.
       * @returns {'success' | 'error' | null}
       */
      returnState() {
        const sentAt = Number(this.take(this.sentKey));
        const sentHere = sentAt > 0 && Date.now() - sentAt < 10 * 60 * 1000;
        const url = new URL(window.location.href);

        if (url.searchParams.get('contact_posted') === 'true') {
          return sentHere || url.hash.indexOf('#TeamwearForm') === 0 ? 'success' : null;
        }

        return sentHere ? 'error' : null;
      }

      load(state) {
        if (this.loaded || this.pending) return;
        // Theme editor without a source product: keep the hint that is printed in the block.
        if (!this.dataset.sourceUrl && window.Shopify && window.Shopify.designMode) return;

        if (this.status) {
          this.status.textContent = this.dataset.msgLoading || '';
          this.status.hidden = false;
        }

        // Coming back after sending: use the copy from before the reload, so the message shows at once.
        const cached = state ? this.read(this.cacheKey) : null;
        const request = cached ? Promise.resolve(cached) : this.fetchForm();

        this.pending = request
          .then((html) => {
            this.insert(html, state);
            this.loaded = true;
          })
          .catch(() => {
            this.pending = null;
            if (this.status) this.status.textContent = this.dataset.msgFailed || '';
          });
      }

      fetchForm() {
        const source = this.dataset.sourceUrl;
        if (!source) return Promise.reject(new Error('Teamwear form: no source product'));

        return fetch(source, { credentials: 'same-origin' })
          .then((response) => {
            if (!response.ok) throw new Error('Teamwear form: HTTP ' + response.status);
            return response.text();
          })
          .then((text) => {
            const form = new DOMParser().parseFromString(text, 'text/html').querySelector('teamwear-form');
            if (!form) throw new Error('Teamwear form: not found on ' + source);
            return form.outerHTML;
          });
      }

      insert(html, state) {
        const template = document.createElement('template');
        template.innerHTML = html;

        const element = template.content.querySelector('teamwear-form');
        const form = element ? element.querySelector('form') : null;
        if (!element || !form) throw new Error('Teamwear form: invalid markup');

        // The request comes from this page, not from the product the form was loaded from.
        ['Produkt', 'Variante', 'Artikelnummer', 'Produkt-URL'].forEach((label) => {
          const input = form.querySelector('input[type="hidden"][name="contact[' + label + ']"]');
          if (input) input.remove();
        });
        this.addField(form, 'Seite', this.dataset.pageTitle || document.title);
        this.addField(form, 'Seiten-URL', window.location.origin + window.location.pathname);

        const steps = element.querySelector('[data-state]');
        if (steps && state) {
          steps.dataset.state = state;

          if (state === 'error' && this.dataset.msgError) {
            const alert = document.createElement('p');
            alert.className = 'teamwear-form__alert';
            alert.setAttribute('role', 'alert');
            alert.textContent = this.dataset.msgError;
            steps.prepend(alert);
          }
        }

        this.store(this.cacheKey, html);
        // From here on the form element takes over: steps, validation, sending and the thank you message.
        this.replaceChildren(element);

        const dialog = this.closest('dialog');
        if (!state && dialog && dialog.open) {
          customElements.whenDefined('teamwear-form').then(() => {
            if (typeof element.focusCurrent === 'function') element.focusCurrent();
          });
        }
      }

      addField(form, label, value) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'contact[' + label + ']';
        input.value = value;
        form.appendChild(input);
      }

      store(key, value) {
        try {
          window.sessionStorage.setItem(key, value);
        } catch (error) {
          // Storage can be unavailable (private mode). The form still works without it.
        }
      }

      read(key) {
        try {
          return window.sessionStorage.getItem(key);
        } catch (error) {
          return null;
        }
      }

      take(key) {
        const value = this.read(key);

        try {
          window.sessionStorage.removeItem(key);
        } catch (error) {
          // Nothing to remove.
        }

        return value;
      }
    }

    customElements.define('teamwear-form-loader', TeamwearFormLoader);
  }
  } catch(e) { console.error(e); }
})();

})();
